import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import { StyledButtonContainer, StyledButton, StyledButtonOutlined } from './styles'
import { StyledTextAfter, StyledTextBefore } from 'components/LinkButton/styles'

const Button = ({
  backBtn,
  children,
  dataGa,
  disabled,
  id,
  isPhotobooth,
  isLock = false,
  onClick = () => {},
  outline,
  type = 'button',
  flat,
  beforeText,
  afterText,
  themeInfos,
  noMargin = false
}) => {
  const theme = useTheme()

  const handleOnClick = (e) => {
    if (backBtn) {
      history.back()
      return
    }

    if (onClick) onClick(e)
  }

  const getStyle = () => {
    if (theme && isLock && !theme.lock_button_outlined) {
      return StyledButton
    }
    if (theme && theme.button_outlined_as_default) {
      return outline ? StyledButton : StyledButtonOutlined
    }
    return outline ? StyledButtonOutlined : StyledButton
  }

  const ButtonStyle = getStyle()

  return (
    <StyledButtonContainer $noMargin={noMargin}>
      {beforeText && <StyledTextBefore>{beforeText}</StyledTextBefore>}

      <ButtonStyle
        id={id}
        type={type}
        onClick={handleOnClick}
        className={disabled ? 'disabled' : ''}
        $isPhotobooth={isPhotobooth}
        style={{ pointerEvents: !onClick && !backBtn && !theme.alatable ? 'none' : null }}
        data-dataga={dataGa || 'button'}
        $flat={flat || false}
        $themeCustom={themeInfos}
      >
        <label>{children}</label>
      </ButtonStyle>

      {afterText && <StyledTextAfter>{afterText}</StyledTextAfter>}
    </StyledButtonContainer>
  )
}

Button.propTypes = {
  backBtn: PropTypes.bool,
  children: PropTypes.node,
  dataGa: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isPhotobooth: PropTypes.bool,
  isLock: PropTypes.bool,
  onClick: PropTypes.func,
  outline: PropTypes.bool,
  type: PropTypes.string,
  flat: PropTypes.bool,
  beforeText: PropTypes.node,
  afterText: PropTypes.node,
  themeInfos: PropTypes.object,
  noMargin: PropTypes.bool
}

export default Button
